import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Project} from "../models/project";
import {environment} from "../../environments/environment";
import {ProjectPhoto} from "../models/project-photo";
import {Observable, shareReplay} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ProjectPhotoService {
  cache: Map<number, Observable<Blob>> = new Map();

  constructor(private httpClient: HttpClient) { }

  list(project: Project) {
    return this.httpClient.get<ProjectPhoto[]>(`${environment.api}/api/v1/project-photos/projects/${project.id}`);
  }

  detail(id: number) {
    return this.httpClient.get<ProjectPhoto>(`${environment.api}/api/v1/project-photos/${id}`);
  }

  download(entity: ProjectPhoto) {
    const result = this.httpClient.get(`${environment.api}/api/v1/project-photos/${entity.id}/download`, {
      responseType: 'blob',
    })
      .pipe(
        shareReplay(1),
      );

    return result;
  }

  downloadMultiple(project: Project, ids: number[]) {
    return this.httpClient.get(`${environment.api}/api/v1/project-photos/download/multiple`, {
      params: { ids: ids.join(',') },
      responseType: 'blob',
    });
  }

  thumbnail(entity: ProjectPhoto) {
    if (this.cache.has(entity.id)) {
      return this.cache.get(entity.id)!;
    }

    const result = this.httpClient.get(`${environment.api}/api/v1/project-photos/${entity.id}/thumbnail`, {
      responseType: 'blob',
    })
      .pipe(
        shareReplay(1),
      );

    this.cache.set(entity.id, result);

    return result;
  }

  delete(entity: ProjectPhoto) {
    return this.httpClient.delete(`${environment.api}/api/v1/project-photos/${entity.id}`);
  }
}
